import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {baseUrl} from "../../../../../../../core/constants/base-url";
import {keyTestModalResourceType} from "../configs/key-tests-modal-config";
import {Observable} from "rxjs";
import {BaseKeyTestData, KeyTestData} from "../types/key-tests-modal.types";
import {RecordsDataRequestQueryParams} from "../../../../../../../core/types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class KeyTestsApiService {
  private http = inject(HttpClient);

  private url: string = `${baseUrl}/${keyTestModalResourceType.path}`;

  public fetchKeyTestSData(queryParams: RecordsDataRequestQueryParams): Observable<Array<KeyTestData>> {
    return this.http.get<Array<any>>(`${this.url}`, { params: queryParams });
  }

  public createKeyTestData(baseKeyTestData: BaseKeyTestData): Observable<KeyTestData> {
    return this.http.post<KeyTestData>(`${this.url}`, baseKeyTestData);
  }
}
